module.exports = __webpack_public_path__ + "static/media/keysight-technologies--big.214a8f2b.svg";